"use client"
import NumberFlow, { continuous, type NumberFlowProps } from "@number-flow/react"

// Matches the HUD's shared transition window (HUD_SYNC_TRANSITION_MS) so the
// tickers settle together with the graph/treemap. Exported for the HUD's
// other bare <NumberFlow> instances (labor legend, agent speed, year pill),
// which otherwise run NumberFlow's much longer defaults and trail the panel.
export const TICKER_NUMBER_FLOW_TIMING: EffectTiming = {
  duration: 500,
  easing: "cubic-bezier(0.22, 1, 0.36, 1)",
}

export const TICKER_NUMBER_FLOW_OPACITY_TIMING: EffectTiming = {
  duration: 200,
  easing: "ease-out",
}

const TICKER_NUMBER_FLOW_PLUGINS = [continuous]

type TickerNumberProps = {
  value: number
  format?: NumberFlowProps["format"]
  prefix?: string
  suffix?: string
}

export const TickerNumber = ({
  value,
  format,
  prefix,
  suffix,
}: TickerNumberProps) => (
  <NumberFlow
    value={value}
    format={format}
    prefix={prefix}
    suffix={suffix}
    plugins={TICKER_NUMBER_FLOW_PLUGINS}
    transformTiming={TICKER_NUMBER_FLOW_TIMING}
    spinTiming={TICKER_NUMBER_FLOW_TIMING}
    opacityTiming={TICKER_NUMBER_FLOW_OPACITY_TIMING}
    willChange
  />
)










